import React from 'react';
import { Mail, Phone } from 'lucide-react';
import IntakeForm from '../components/shared/IntakeForm';

export default function Contact() {
  return (
    <div className="bg-gray-950 text-white pt-20">
      <section className="py-16 px-6 border-b border-gray-800">
        <div className="container mx-auto max-w-4xl text-center">
          <p className="text-blue-400 font-semibold tracking-widest uppercase text-sm mb-4">Contact</p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Start With the Intake Form</h1>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">Tell Weldon what you need reviewed. He will review your request and follow up directly with the best option, package, pricing, and next steps.</p>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="container mx-auto max-w-2xl">
          <IntakeForm />
        </div>
      </section>

      <section className="py-12 px-6 bg-gray-900 border-t border-gray-800">
        <div className="container mx-auto max-w-3xl">
          <h2 className="text-2xl font-bold text-center mb-8">Other Ways to Reach Weldon</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <a href="mailto:weldonbraxton@gmail.com" className="bg-gray-950 border border-gray-800 rounded-xl p-5 text-center hover:border-blue-600/40 transition-colors">
              <Mail className="h-6 w-6 text-blue-500 mx-auto mb-2" />
              <p className="text-sm font-medium text-gray-300">Email</p>
            </a>
            <a href="https://twitter.com/coachwbraxton" target="_blank" rel="noopener noreferrer" className="bg-gray-950 border border-gray-800 rounded-xl p-5 text-center hover:border-blue-600/40 transition-colors">
              <svg className="h-6 w-6 text-blue-500 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              <p className="text-sm font-medium text-gray-300">X / Twitter</p>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
